export { default as linkpickfr } from './lib/linkpick/fr';
export { default as backofficefr } from './lib/backoffice/fr';
